"use client"

import React from "react"

import { useTranslation } from "#modules/localization/translations.client"

/**
 * Used to format price display with language (and currency in future) - client component because its used in both client cartItems and server cartItems (popup and page and for optimistic display on client)
 */
export function Price({ price, priceClassName, className }: { price: number; className?: string; priceClassName?: string }) {
  const { t } = useTranslation("glossar")

  return (
    <p className={className}>
      {t("generic.price")} <span className={priceClassName}>{price}€</span>
    </p>
  )
}
